import { render, staticRenderFns } from "./Mention.vue?vue&type=template&id=297bb5fa&scoped=true"
import script from "./Mention.vue?vue&type=script&lang=js"
export * from "./Mention.vue?vue&type=script&lang=js"
import style0 from "./Mention.vue?vue&type=style&index=0&id=297bb5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297bb5fa",
  null
  
)

export default component.exports